module.exports = __webpack_public_path__ + "img/809ef1cb59d4fa7b6e107cbeea445f93.svg";